import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Observable, of } from "rxjs";
import { mergeMap, catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class InterceptorService implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // don't send authorization header to untrusted endpoints
    if (
      !req.url.startsWith(environment.backend.apiBaseUrl) ||
      (req.url === `${environment.backend.apiBaseUrl}/accounts` &&
        req.method === "POST")
    ) {
      return next.handle(req);
    }

    // Only a failed token lookup falls back to an unauthenticated request.
    // The request's own errors (401, 409, 500, ...) must reach the caller
    // untouched: an earlier version caught them here too and re-sent the
    // request without the header, so every API error surfaced as a 401.
    return this.auth.getToken().pipe(
      catchError((_) => of<string | null>(null)),
      mergeMap((token) => {
        if (!token) {
          return next.handle(req.clone({}));
        }
        const tokenReq = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
        return next.handle(tokenReq);
      })
    );
  }
}
